import React from 'react'
import Navbar from 'react-bootstrap/Navbar'

const Header = () => (
    <div>
        <Navbar expand="lg" variant="light" bg="light">
            <Navbar.Brand>Common Notes</Navbar.Brand>
        </Navbar>
    </div>
)

export default Header